import { defineMessages } from 'react-intl';

export const FAQ_LINKS = [
  { articleNumber: '3207', messageKey: 'faqRefund' as const },
  { articleNumber: '7610', messageKey: 'faqCharge' as const },
  { articleNumber: '4092', messageKey: 'faqUpdateTicket' as const },
  { articleNumber: '3776', messageKey: 'faqWhereTickets' as const },
] as const;

export const CONTACT_REASONS = [
  { value: 'question_about_event', messageKey: 'reasonEvent' as const },
  { value: 'question_about_my_ticket', messageKey: 'reasonTicket' as const },
] as const;

/**
 * Mirrors the server-side limit enforced by `CreateContactOrganizer` in core
 * (`ebapi/views/organizers.py` and
 * `ebapi_service/actions/contact_organizer.py`): anything longer is rejected
 * with a 400 ARGUMENTS_ERROR.
 */
export const MAX_LENGTH_MESSAGE = 1024;

export const messages = defineMessages({
  modalTitle: {
    id: 'Contact the organizer',
    defaultMessage: 'Contact the organizer',
  },
  closeModal: {
    id: 'Close contact dialog',
    defaultMessage: 'Close contact dialog',
  },

  // Landing view
  faqHeading: {
    id: 'Frequently asked questions:',
    defaultMessage: 'Frequently asked questions:',
  },
  faqRefund: {
    id: 'Can I get a refund?',
    defaultMessage: 'Can I get a refund?',
  },
  faqCharge: {
    id: 'What is this charge from Eventbrite? (EB *Charge)',
    defaultMessage: 'What is this charge from Eventbrite? (EB *Charge)',
  },
  faqUpdateTicket: {
    id: 'How to update your ticket/registration information',
    defaultMessage: 'How to update your ticket/registration information',
  },
  faqWhereTickets: {
    id: 'Where are my tickets?',
    defaultMessage: 'Where are my tickets?',
  },
  haveQuestion: {
    id: 'Have a question for the organizer?',
    defaultMessage: 'Have a question for the organizer?',
  },
  checkEventPage: {
    id: 'Check the event page for more information or',
    defaultMessage: 'Check the event page for more information or',
  },
  contactOrganizer: {
    id: 'Contact the organizer',
    defaultMessage: 'Contact the organizer',
  },

  // Form view
  labelName: {
    id: 'Your Name',
    defaultMessage: 'Your Name',
  },
  labelEmail: {
    id: 'Email Address',
    defaultMessage: 'Email Address',
  },
  labelReason: {
    id: 'Contact reason',
    defaultMessage: 'Contact reason',
  },
  labelMessage: {
    id: 'Message',
    defaultMessage: 'Message',
  },
  reasonEvent: {
    id: 'Question about the event',
    defaultMessage: 'Question about the event',
  },
  reasonTicket: {
    id: 'Question about my ticket',
    defaultMessage: 'Question about my ticket',
  },
  selectPlaceholder: {
    id: 'Select one',
    defaultMessage: 'Select one',
  },
  privacyNotice: {
    id: 'Your email will only be seen by the event organizer. <privacyLink>View privacy policy.</privacyLink>',
    defaultMessage:
      'Your email will only be seen by the event organizer. <privacyLink>View privacy policy.</privacyLink>',
  },
  continueButton: {
    id: 'Continue',
    defaultMessage: 'Continue',
  },
  backButton: {
    id: 'Back',
    defaultMessage: 'Back',
  },
  formValidationBanner: {
    id: 'There are errors with the provided information.',
    defaultMessage: 'There are errors with the provided information.',
  },
  emptyFieldError: {
    id: 'This field is required',
    defaultMessage: 'This field is required',
  },
  invalidEmailError: {
    id: 'Must provide a valid email',
    defaultMessage: 'Must provide a valid email',
  },
  messageTooLongError: {
    id: 'Your message must be {maxLength} characters or fewer.',
    defaultMessage: 'Your message must be {maxLength} characters or fewer.',
  },

  // Confirmation view
  contactInfoHeading: {
    id: 'Contact Information',
    defaultMessage: 'Contact Information',
  },
  yourName: {
    id: 'Your name:',
    defaultMessage: 'Your name:',
  },
  yourEmail: {
    id: 'Your email:',
    defaultMessage: 'Your email:',
  },
  contactReason: {
    id: 'Contact Reason',
    defaultMessage: 'Contact Reason',
  },
  messageLabel: {
    id: 'Message',
    defaultMessage: 'Message',
  },
  editInformation: {
    id: 'Edit Information',
    defaultMessage: 'Edit Information',
  },
  submitRequest: {
    id: 'Submit Request',
    defaultMessage: 'Submit Request',
  },

  // Confirmation errors
  errorBadRequest: {
    id: 'There was an error processing your request.',
    defaultMessage: 'There was an error processing your request.',
  },
  errorCaptcha: {
    id: 'Captcha was incorrect. Please go back and try again.',
    defaultMessage: 'Captcha was incorrect. Please go back and try again.',
  },

  // Success view
  successTitle: {
    id: 'Your message was submitted successfully!',
    defaultMessage: 'Your message was submitted successfully!',
  },
  successSubtitle: {
    id: 'Organizers typically respond within 4 business days.',
    defaultMessage: 'Organizers typically respond within 4 business days.',
  },
  doneButton: {
    id: 'Done',
    defaultMessage: 'Done',
  },
});

export const API_ERROR_MAP: Record<string, keyof typeof messages> = {
  BAD_REQUEST: 'errorBadRequest',
  CAPTCHA: 'errorCaptcha',
  INTERNAL_ERROR: 'errorBadRequest',
  DEFAULT: 'errorBadRequest',
};
